module.exports = __webpack_public_path__ + "static/media/arrow-square-left.94af8dfb.svg";